class SizeToggle extends HTMLElement {
    constructor() {
        super();
        this.inchFactor = 2.54;
        this.sizeCentimetersCheckbox = this.querySelectorAll('.sizeCentimetersCheckbox');
        this.sizeInchesCheckbox = this.querySelectorAll('.sizeInchesCheckbox');
        this.init();
    }

    init() {
        this.sizeCentimetersCheckbox.forEach((checkbox) => {
            checkbox.addEventListener('click', () => this.handleCheckboxClick(checkbox));
        });
        this.sizeInchesCheckbox.forEach((checkbox) => {
            checkbox.addEventListener('click', () => this.handleCheckboxClick(checkbox));
        });
    }

    handleCheckboxClick(checkbox) {
        const inputElement = checkbox.querySelector('input');

        if (checkbox.classList.contains('sizeInchesCheckbox') && !inputElement.checked) {
            this.setSizeValue('in');
        } else if (checkbox.classList.contains('sizeCentimetersCheckbox') && !inputElement.checked) {
            this.setSizeValue('cm');
        }

        if (inputElement) {
            inputElement.checked = true;
        }
    }

    setSizeValue(type) {
        const sizeElements = this.querySelectorAll('.size-value');
        sizeElements.forEach((element) => {
            let valueRange = element.textContent.split('-');
            const convertedValues = valueRange.map((value) =>
                type === 'cm'
                    ? (Math.round(value * this.inchFactor * 10) / 10).toString().replace('.0', '')
                    : (Math.round(value / this.inchFactor * 10) / 10).toString().replace('.0', '')
            );
            element.textContent = convertedValues.join('-');
        });
    }
}

customElements.define('size-toggle', SizeToggle);